/**
 * DER PULS: WAS ANDERE ÄNDERN, UND OB EINE NEUE VERSION LÄUFT.
 * ============================================================================
 *
 * ORIGINALTEXT MARVIN (23.09.2026)
 *   „ich brauche einen automatischen push, wenn ein update auf dem server
 *    ausgerollt wurde. außerdem brauche ich immer einen automatischen push,
 *    wenn zb jemand daten ändert im system, ich auch die gleiche ansicht auf
 *    habe, dass ich sofort neue daten gepusht bekomme und nicht erst die
 *    ansicht wechseln muss und dann wieder zurückgehen um die aktuelle
 *    ansicht zu erhalten."
 *
 * Alle 4 Sekunden fragt dieses Fenster `GET /api/puls`. Die Antwort trägt
 * den Zeitpunkt der letzten Änderung im Haus und die Versionsnummer des
 * Servers (siehe `api/src/live.ts`).
 *
 *   - Ist der Zeitpunkt neuer als der letzte, zieht jede offene Ansicht nach
 *     (`allesNachziehen`), mit ihrer eigenen Ladefunktion.
 *   - Weicht die Version von der dieser Seite ab, ist ein Update ausgerollt.
 *
 * NICHT, WÄHREND JEMAND SCHREIBT. Liegt der Fokus in einem Eingabefeld oder
 * ist ein Fenster offen, wartet der Nachzug, bis beides vorbei ist. Sonst
 * setzt ein fremdes Speichern womöglich den Entwurf zurück, an dem man gerade
 * tippt.
 *
 * NICHT IM HINTERGRUND. Ist das Fenster verdeckt, ruht die Abfrage; beim
 * Zurückkommen fragt es sofort einmal.
 *
 * Die Entscheidung steht in reinen Funktionen (`sollNachziehen`,
 * `beschaeftigt`), damit ein Prüfstand sie laden kann.
 */

export const TAKT_MS = 4_000;

export interface Pulsstand {
  version: string | null;
  aenderung: number | null;
  /** .583: Fingerabdruck der eigenen Rechte und des Menüs. */
  zugang?: string | null;
}

/** Hat sich der Zugang geändert? Die erste Antwort ist der Ausgangspunkt. */
export function zugangGeaendert(bekannt: string | null, neu: string | null | undefined): boolean {
  return !!bekannt && !!neu && bekannt !== neu;
}

/** Ist dieser Zeitpunkt eine Änderung, die das Fenster noch nicht kennt? */
export function sollNachziehen(bekannt: number | null, neu: number | null): boolean {
  if (neu === null || neu === undefined) return false;
  if (bekannt === null) return false;          // die erste Antwort ist der Ausgangspunkt
  return neu > bekannt;
}

/** Tippt gerade jemand, oder ist ein Fenster offen? */
export function beschaeftigt(doc: { activeElement: any; querySelector: (s: string) => any }): boolean {
  const a = doc.activeElement;
  if (a) {
    const tag = String(a.tagName ?? '').toUpperCase();
    const typ = String(a.type ?? '').toLowerCase();
    if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (tag === 'INPUT' && !['checkbox', 'radio', 'button', 'submit'].includes(typ)) return true;
    if (a.isContentEditable) return true;
  }
  return !!doc.querySelector('.dialoggrund, dialog[open]');
}

/** Läuft auf dem Server eine andere Version als in diesem Fenster? */
export function neueVersion(dieseSeite: string, server: string | null): boolean {
  return !!server && !!dieseSeite && dieseSeite !== 'unbekannt' && server !== dieseSeite;
}
